export default {
  name: 'StrokedChevronLeftIocn',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    },
    color: {
      type: String,
      default: '#AFACAC'
    }
  }
};